import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import AssetTransferForm from './components/AssetTransfer/AssetTransferForm';
import AssetTransferTable from './components/AssetTransfer/AssetTransferTable';
import AsssetMaterTable from './components/AsssetMaterTable';
import PreventiveMaintenance from './components/Preventive Maintenance/PreventiveMaintenance';
import PlanOverview from './components/Preventive Maintenance/PlanOverview';
import CreatePlan from './components/Preventive Maintenance/CreatePlan';
import AddPlan from './components/Preventive Maintenance/AddPlan';
import EditCheckPoint from './components/Preventive Maintenance/EditCheckPoint';
import CheckPointActivity from './components/Preventive Maintenance/CheckPointActivity';
import CheckpointDetail from './components/Preventive Maintenance/CheckpointDetail';
import Rescheduleplan from './components/Preventive Maintenance/Rescheduleplan';
import Logoverview from './components/Preventive Maintenance/Logoverview';
import Reports from './components/Preventive Maintenance/Reports';
import NGcheckpoints from './components/Preventive Maintenance/NGcheckpoints';
import NGApprovecheckpoints from './components/Preventive Maintenance/NGApproveCheckpoints';
import Breakdown from './components/BreakDown/Breakdown';
// import ReportBreakdown from './components/BreakDown/ReportBreakdown';
import TriggerBreakdown from './components/BreakDown/TriggerBreakdown';
import SelectAsset from './components/BreakDown/SelectAsset';
import AddDetails from './components/BreakDown/AddDetails';
import CurrentBreakdown from './components/BreakDown/CurrentBreakdown';
import TodayBreakdown from './components/BreakDown/TodayBreakdown';
import AttendBreakdown from './components/BreakDown/AttendBreakdown';
import BreakdownHistory from './components/BreakDown/BreakdownHistory';
import Camera from './components/BreakDown/Camera';
import AddObservation from './components/BreakDown/AddObservation';
import SpareList from './components/BreakDown/SpareList';
import ApproverList from './components/BreakDown/ApproverList';
import PendingApproval from './components/BreakDown/PendingApproval';
import BreakdownDetails from './components/BreakDown/BreakdownDetails';
import ApproveBreakdown from './components/BreakDown/ApproveBreakdown';
import PendingNotes from './components/BreakDown/PendingNotes';
import AddNotes from './components/BreakDown/AddNotes';
import WhyWhyAnalysis from './components/BreakDown/WhyWhyAnalysis';
import RootCauseAnalysis from './components/BreakDown/RootCauseAnalysis';
import PhysicalVerification from './components/PhysicalVerification/PhysicalVerification';
import CreatePlanSupplier from './components/PhysicalVerification/CreatePlanSupplier';
import PVPlanView from './components/PhysicalVerification/PVPlanView';
import PVchecklist from './components/PhysicalVerification/PVChecklist';
import CheckPointVerification from './components/PhysicalVerification/CheckpointVerification';
import PVngchechpoints from './components/PhysicalVerification/PVngchechpoints';
import PvNgApprove from './components/PhysicalVerification/PvNgApprove';
import PVRescheduleplan from './components/PhysicalVerification/PVRescheduleplan';
import PVReports from './components/PhysicalVerification/PVReports';
import WebcamCapture from './components/Preventive Maintenance/WebcamCapture';
// import CSVReader from 'react-csv-reader';
import CsvUploader from './components/CsvReader';
import PVLogoverview from './components/PhysicalVerification/PVLogOverview';
import VendorWithAssets from './components/PhysicalVerification/VendorWithAssets';
import BreakdownLogs from './components/BreakDown/BreakdownLogs';
import AssetTransferDetails from './components/AssetTransfer/AssetTransferDetails';
import AssetDisposalRequest from './components/AssetDisposal/AssetDisposalRequest';
import AssetDisposalTable from './components/AssetDisposal/AssetDisposalTable';
import AssetDisposalDetail from './components/AssetDisposal/AssetDisposalDetail';
import PLISelectAsset from './components/PLI Physical Verification/PLISelectAsset';
import PLIForm from './components/PLI Physical Verification/PLIForm';
import PLILogs from './components/PLI Physical Verification/PLILogs';
import UploadAssetDeclaration from './components/AssetDeclaration/UploadDeclaration';
import AsssetDeclarationHistory from './components/AssetDeclaration/AsssetDeclarationHistory';
import PLIDetails from './components/PLI Physical Verification/PLIDetails';
import AssetDeclarationVendorList from './components/AssetDeclaration/AssetDeclarationVendorList';
import ApproveChecksheet from './components/Preventive Maintenance/ApproveChecksheet';
import ChecksheetDetail from './components/Preventive Maintenance/ChecksheetDetail';
import Settings from './components/Settings/Setting';
import UserManagement from './components/Settings/UserManagement';
import AddUser from './components/Settings/AddUser';
import ViewUserList from './components/Settings/ViewUserList';
import DataUpload from './components/Settings/DataUpload';
import MailManagement from './components/Settings/MailManagement';
import AddBroadCastChannel from './components/Settings/AddBroadCastChannel';
import AddBroadcastUsers from './components/Settings/AddBroadcastUsers';
import AddTemplate from './components/Settings/AddTemplate';
import AddEvent from './components/Settings/AddEvent';
import PLITable from './components/PLI Physical Verification/PLITable';
import Support from './components/Support';
import ProtectedRoute from './utils/ProtectedRoutes';
import BDReports from './components/BreakDown/BDReports';
import Redis from './components/Settings/Redis';
import DataManagement from './components/Settings/DataManagement';
import DownloadData from './components/Settings/DownloadData';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import ErrorHandlerUI from './helpers/ErrorHandlerUI';
import BulkPVPlan from './components/Settings/BulkPVPlan';
import HomePage from './pages/HomePage';
// import Main from './pages/Main';
const Main = lazy(() => import('./pages/Main'));




// // Custom fallback UI component
// function ErrorFallback({ error, resetErrorBoundary }) {
//   return (
//     <div role="alert" style={{ padding: '20px', textAlign: 'center' }}>
//       <h2>Something went wrong:</h2>
//       <pre style={{ color: 'red' }}>{error.message}</pre>
//       <button onClick={resetErrorBoundary} style={{ margin: '10px' }}>Try Again</button>
//     </div>
//   );
// }

// Function to log errors (could be extended to send to an external service)
function logErrorToService(error, info) {
  console.info("Logged Error:", error, "Info:", info);
}


function App() {

  return (
    <BrowserRouter>
      <Suspense fallback={<GridLoadingSpinner />}>
        <Routes>
          <Route path='/' element={
            <HomePage />
          } />
          <Route path='/dashboard' element={
            <Main />
          } />
          {/* <Route
            path='/'
            element={
              <ErrorBoundary
                FallbackComponent={ErrorHandlerUI}
                onError={logErrorToService}
                onReset={() => window.location.reload()}
              >
                <Main />
              </ErrorBoundary>
            }
          /> */}
          <Route path='/asset-master-table' element={<AsssetMaterTable />} />

          <Route path='/preventive-maintenance' element={<PreventiveMaintenance />} />
          <Route path='/plan-overview' element={<PlanOverview />} />
          <Route path='/create-plan' element={<CreatePlan />} />
          <Route path='/add-plan/*' element={<AddPlan />} />
          <Route path='/edit-checkpoint/' element={<EditCheckPoint />} />
          <Route path='/checkpoint-activity/*' element={<CheckPointActivity />} />
          <Route path='/checkpoint-details/*' element={<CheckpointDetail />} />
          <Route path='/reschedule-plan' element={<Rescheduleplan />} />
          <Route path='/pm/log-overview' element={<Logoverview />} />
          <Route path='/reports' element={<Reports />} />
          <Route path='/ng-checkpoints' element={<NGcheckpoints />} />
          <Route path='/ng-checkpoints/approve' element={<NGApprovecheckpoints />} />
          <Route path='/preventive-maintenance/approve-checksheet' element={<ApproveChecksheet />} />
          <Route path='/preventive-maintenance/checksheet/*' element={<ChecksheetDetail />} />

          <Route path='/breakdown-management' element={<Breakdown />} />
          {/* <Route path='/report-breakdown' element={<ReportBreakdown />} /> */}
          <Route path='/report-breakdown/select-asset' element={<SelectAsset />} />
          <Route path='/report-breakdown/add-details/*' element={<AddDetails />} />
          <Route path='/trigger-breakdown' element={<TriggerBreakdown />} />
          <Route path='/breakdown-management/current-breakdowns' element={<CurrentBreakdown />} />
          <Route path='/breakdown-management/todays-breakdowns' element={<TodayBreakdown />} />
          <Route path='/breakdown-management/pending-approvals' element={<PendingApproval />} />
          <Route path='/attend-breakdown/*' element={<AttendBreakdown />} />
          <Route path='/attend-breakdown/breakdown-history/*' element={<BreakdownHistory />} />
          <Route path='/attend-breakdown/camera' element={<Camera />} />
          <Route path='/attend-breakdown/add-observation/*' element={<AddObservation />} />
          <Route path='/attend-breakdown/spare-list' element={<SpareList />} />
          <Route path='/attend-breakdown/approver-list/*' element={<ApproverList />} />
          <Route path='/breakdown-details/*' element={<BreakdownDetails />} />
          <Route path='/approve-breakdown/*' element={<ApproveBreakdown />} />
          <Route path='/breakdown-management/pending-notes' element={<PendingNotes />} />
          <Route path='/breakdown-management/pending-notes/add-notes/*' element={<AddNotes />} />
          <Route path='/breakdown-management/root-cause-analysis' element={<RootCauseAnalysis />} />
          <Route path='/breakdown-management/why-why-analysis/*' element={<WhyWhyAnalysis />} />
          <Route path='/breakdown-management/break-down-logs' element={<BreakdownLogs />} />
          <Route path='/breakdown-management/bd-reports' element={<BDReports />} />

          <Route path='/physical-verification' element={<PhysicalVerification />} />
          <Route path='/physical-verification/create-plan' element={<CreatePlanSupplier />} />
          <Route path='/physical-verification/checklist/*' element={<PVchecklist />} />
          <Route path='/physical-verification/plan-overview' element={<PVPlanView />} />
          <Route path='/physical-verification/plan-overview/vendor/*' element={<VendorWithAssets />} />
          <Route path='/physical-verification/log-overview' element={<PVLogoverview />} />
          <Route path='/physical-verification/checkpoint-verification/*' element={<CheckPointVerification />} />
          <Route path='/physical-verification/ng-checkpoints' element={<PVngchechpoints />} />
          <Route path='/physical-verification/ng-approve-checkpoints' element={<PvNgApprove />} />
          <Route path='/physical-verification/reschedule-plan' element={<PVRescheduleplan />} />
          <Route path='/physical-verification/reports' element={<PVReports />} />
          <Route path='/physical-verification/camera' element={<WebcamCapture />} />
          <Route path='/csv' element={<CsvUploader />} />
          {/* <Route path='/sample' element={<AssetTransfer />} /> */}

          {/* <Route path='/asset-transfer-form/:id' element={<AssetTransferForm />} /> */}
          <Route path='/asset-transfer-form' element={
            <ProtectedRoute allowedRoles={['admin', 'asset_transfer']}>
              <AssetTransferForm />
            </ProtectedRoute>
          } />
          <Route path='/asset-transfer-table' element={<AssetTransferTable />} />
          <Route path='/asset-transfer-details/*' element={<AssetTransferDetails />} />

          <Route path='/asset-disposal-req' element={
            <ProtectedRoute allowedRoles={['admin', 'asset_dispose']}>
              <AssetDisposalRequest />
            </ProtectedRoute>
          } />

          <Route path='/asset-disposal-table' element={
            <ProtectedRoute allowedRoles={['admin', 'asset_dispose', 'view_only']}>
              <AssetDisposalTable />
            </ProtectedRoute>
          } />
          <Route path='/asset-disposal-details/*' element={
            <ProtectedRoute allowedRoles={['admin', 'asset_dispose', 'view_only']}>
              <AssetDisposalDetail />
            </ProtectedRoute>
          } />

          <Route path='/pli/select-asset' element={<PLISelectAsset />} />
          <Route path='/pli-form/*' element={<PLIForm />} />
          <Route path='/pli-table' element={<PLITable />} />
          <Route path='/pli-history/*' element={<PLILogs />} />
          <Route path='/pli-details/*' element={<PLIDetails />} />

          <Route path='/upload-asset-declaration' element={
            <ProtectedRoute allowedRoles={['admin', 'supplier']}>
              <UploadAssetDeclaration />
            </ProtectedRoute>
          } />

          <Route path='/asset-declaration-history/*' element={<AsssetDeclarationHistory />} />
          <Route path='/asset-declaration/vendor-list' element={<AssetDeclarationVendorList />} />

          <Route
            path="/settings"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route path='/user-management' element={
            <ProtectedRoute allowedRoles={['admin']}>
              < UserManagement />
            </ProtectedRoute>
          }
          />
          <Route path='/user-management/add-user/*' element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AddUser />
            </ProtectedRoute>
          } />
          <Route path='/user-management/view-User-list' element={
            <ProtectedRoute allowedRoles={['admin']}>
              <ViewUserList />
            </ProtectedRoute>
          } />

          <Route path='/data-management' element={
            <ProtectedRoute allowedRoles={['admin']}>
              {/* <DataUpload /> */}
              <DataManagement />
            </ProtectedRoute>
          } />
          <Route path='/data-management/upload-data' element={
            <ProtectedRoute allowedRoles={['admin']}>
              <DataUpload />
            </ProtectedRoute>
          } />
          <Route path='/data-management/download-data' element={
            <ProtectedRoute allowedRoles={['admin']}>
              <DownloadData />
            </ProtectedRoute>
          } />
          <Route path='/mail-management' element={
            <ProtectedRoute allowedRoles={['admin']}>
              <MailManagement />
            </ProtectedRoute>
          } />
          <Route path='/mail-management/add-broadcast-channel' element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AddBroadCastChannel />
            </ProtectedRoute>
          } />
          <Route path='/mail-management/add-broadcast-users' element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AddBroadcastUsers />
            </ProtectedRoute>
          } />
          <Route path='/mail-management/add-templates' element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AddTemplate />
            </ProtectedRoute>
          } />
          <Route path='/mail-management/add-event' element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AddEvent />
            </ProtectedRoute>
          } />

          <Route path='/setting/redis' element={
            <ProtectedRoute allowedRoles={['admin']}>
              <Redis />
            </ProtectedRoute>
          } />

          <Route path='/bulk-pv-plan-create' element={
            <ProtectedRoute allowedRoles={['admin']}>
              <BulkPVPlan />
            </ProtectedRoute>
          } />

          <Route path='/support' element={<Support />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
